import React, { useEffect, useState } from "react";
import { ButtonComponent, DatePickerComponent, InputField, PercentageInputBox, PriceInputBox, SelectBox } from "../component/Common";
import { businessRoles, employmentStatus, employmentTypeList, occupationList, otherIncomeList, universalBenifitsList, yesNoArray } from "../constants/form_constatnts";
import '../style/employmentForm.css';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import api from "../utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import { validateDates } from "../utils/validate";

//employment form array 
const EmploymentStatus = ({ onNextPage, onPriviousPage }) => {
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);
    const [emlpoymentData, setemlpoymentData] = useState({
        employmentStatus: '',
        retirementAge: '',
        //employment fields
        occupation: '',
        employmentStartDate: null,
        employmentType: '',
        annualSalary: null,
        monthlySalary: null,
        taxRate: null,
        employerName: '',
        companyRegisteredAddress: '',
        previousEmployerName: '',
        previousJobStartDate: null,
        previousSalary: null,
        previousEmployersAddress: '',
        //common fields
        universalCreditSource: '',
        universalCreditAmount: null,
        universalCreditBank: '',
        NInumber: '',
        accountantFirm: '',
        actingAccountant: '',
        address: '',
        postCode: '',
        otherIncomeStatus: '',
        otherIncome: [
            {
                otherIncomeSource: '',
                otherIncomeAmount: null,
            }
        ],
        //business array
        business: [
            {
                businessRole: '',
                businessPercentage: null,
                selfBusinessName: '',
                selfEmploymentDuration: null,
                latestAccountingYear: null,
                latestYearTotalIncome: null,
                latestYearsNetProfit: null,
                latestYearsSalary: null,
                latestYearsProfitFromLands: null,
                latestYearsDividends: null,
                previousAccountingYear: null,
                previousYearTotalIncome: null,
                previousYearsNetProfit: null,
                previousYearsSalary: null,
                previousYearsProfitFromLands: null,
                previousYearsDividends: null,
            }
        ]
    })

    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const applicationId = searchParams.get('applicationId');

    useEffect(() => {
        if (!isInitialLoad) {
            if (applicationId) {
                fetchEmploymentData(applicationId);
            }
        }
    }, [isInitialLoad]);

    const fetchEmploymentData = async (id) => {
        try {
            const result = await api.get(`/get-employment-details/${id}`);
            const data = result.data.EmploymentDetails;

            if (data) {
                const updatedData = {
                    employmentStatus: employmentStatus.find(option => option.value === data.employmentStatus) || '',
                    retirementAge: data.retirementAge,
                    universalCreditSource: universalBenifitsList.find(option => option.value === data.universalCreditSource) || '',
                    universalCreditAmount: data.universalCreditAmount,
                    universalCreditBank: data.universalCreditBank,
                    NInumber: data.NInumber,
                    accountantFirm: data.accountantFirm,
                    actingAccountant: data.actingAccountant,
                    address: data.address,
                    postCode: data.postCode,
                    otherIncomeStatus: yesNoArray.find(option => option.value === data.otherIncomeStatus) || '',

                };

                // Handle `Employed` and `Both` employment statuses
                if (data.employmentStatus === 'Employed' || data.employmentStatus === 'Both') {
                    updatedData.occupation = occupationList.find(option => option.value === data.employedData?.occupation) || '';
                    updatedData.employmentStartDate = data.employedData?.employmentStartDate;
                    updatedData.employmentType = employmentTypeList.find(option => option.value === data.employedData?.employmentType) || '';
                    updatedData.annualSalary = data.employedData?.annualSalary;
                    updatedData.monthlySalary = data.employedData?.monthlySalary;
                    updatedData.taxRate = data.employedData?.taxRate;
                    updatedData.employerName = data.employedData?.employerName;
                    updatedData.companyRegisteredAddress = data.employedData?.companyRegisteredAddress;
                    updatedData.previousEmployerName = data.employedData?.previousEmployerName;
                    updatedData.previousJobStartDate = data.employedData?.previousJobStartDate;
                    updatedData.previousSalary = data.employedData?.previousSalary;
                    updatedData.previousEmployersAddress = data.employedData?.previousEmployersAddress;
                }

                // Handle `Self-Employed` and `Both` employment statuses
                if ((data.employmentStatus === 'Self-Employed' || data.employmentStatus === 'Both') && data.selfEmployedData?.length > 0) {
                    updatedData.business = data.selfEmployedData.map(row => ({
                        id: row.id,
                        businessRole: businessRoles.find(option => option.value === row.businessRole) || '',
                        businessPercentage: row.businessPercentage,
                        selfBusinessName: row.businessName,
                        selfEmploymentDuration: row.employmentDuration,
                        latestAccountingYear: row.latestAccountingYear,
                        latestYearTotalIncome: row.latestYearTotalIncome,
                        latestYearsNetProfit: row.latestYearsNetProfit,
                        latestYearsSalary: row.latestYearsSalary,
                        latestYearsProfitFromLands: row.latestYearsProfitFromLands,
                        latestYearsDividends: row.latestYearsDividends,
                        previousAccountingYear: row.previousAccountingYear,
                        previousYearTotalIncome: row.previousYearTotalIncome,
                        previousYearsNetProfit: row.previousYearsNetProfit,
                        previousYearsSalary: row.previousYearsSalary,
                        previousYearsProfitFromLands: row.previousYearsProfitFromLands,
                        previousYearsDividends: row.previousYearsDividends,
                    }));
                }

                // Update state
                setemlpoymentData(prevData => ({
                    ...prevData,
                    ...updatedData,
                }));

                if (data.otherIncomeStatus == "Yes") {
                    setemlpoymentData(prevData => ({
                        ...prevData,
                        otherIncome: data.otherInconeData.map(row => ({
                            id: row.id,
                            otherIncomeSource: otherIncomeList.find(option => option.value === row.otherIncomeSource) || '',
                            otherIncomeAmount: row.otherIncomeAmount,
                        })),
                    }));
                }
            }
        } catch (error) {
            console.log("Error fetching employment details:", error);
        }
    };

    //handle error message
    useEffect(() => {
        for (const key in errors) {
            const errorMessageElement = document.getElementById(`error-message-${key}`);
            const dateErrorMessageElement = document.getElementById(`date-error-message-${key}`);
            const input = document.getElementById(`${key}`);
            if (errorMessageElement) {
                errorMessageElement.textContent = errors[key];
                if (input && input.tagName.toLowerCase() == 'input') {
                    if (errorMessageElement.textContent == '') {
                        input.style.setProperty('border', '1px solid #ccc', 'important');
                        input.style.setProperty('border-radius', '4px', 'important');
                    } else {
                        input.style.setProperty('border', '1px solid red', 'important');
                        input.style.setProperty('border-radius', '4px', 'important');
                    }
                }
            }
            if (dateErrorMessageElement) {
                dateErrorMessageElement.textContent = errors[key];
                if (input) {
                    const wrapper = input.getElementsByClassName('react-date-picker__wrapper')[0];
                    if (wrapper) {
                        if (dateErrorMessageElement.textContent === '') {
                            wrapper.style.setProperty('border', '1px solid gray', 'important');
                        } else {
                            wrapper.style.setProperty('border', '1px solid red', 'important');
                        }
                    }
                }
            }
        }
    }, [errors]);

    // Handle change for select inputs
    const handleSelectChange = (value, name) => {
        setemlpoymentData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevData) => ({ ...prevData, [name]: "" }));
    };

    // Custom styles for react-select to handle error borders
    const customSelectStyles = (fieldName) => ({
        control: (provided) => ({
            ...provided,
            borderColor: errors[fieldName] ? 'red' : provided.borderColor,
            '&:hover': {
                borderColor: errors[fieldName] ? 'red' : provided['&:hover'].borderColor,
            },
        }),
    });

    // Handle date change
    const handleDateChange = (date, name, id) => {
        setemlpoymentData((prevData) => {
            const updatedData = { ...prevData, [name]: date };
            if (name === 'employmentStartDate' || name === 'previousJobStartDate') {
                const errorMessage = validateDates(updatedData.previousJobStartDate, updatedData.employmentStartDate, id);
                console.log("Validation Result:", errorMessage);
                setErrors((prevData) => ({ ...prevData, [name]: errorMessage }));
            }
            return updatedData;
        });
    };

    //handle price change
    const handlePriceChange = (e) => {
        const { id, value } = e.target;
        let formattedValue = value;
        setemlpoymentData((prevData) => ({ ...prevData, [id]: formattedValue }));
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[id];
            return newErrors;
        });
    }

    //handle input change
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setemlpoymentData((prevData) => ({ ...prevData, [id]: value }));
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[id];
            return newErrors;
        });
    };

    //handle busniess change(add more business...)
    const handleBusinessChange = (index, name, value) => {
        const newBusiness = [...emlpoymentData.business];
        newBusiness[index] = {
            ...newBusiness[index],
            [name]: value
        };
        setemlpoymentData({ ...emlpoymentData, business: newBusiness });
        setErrors((prevData) => ({ ...prevData, [`${name}${index}`]: "" }));
    };
    //handle  other income field select 
    const handleIncomeChange = (index, name, value) => {
        const newIncome = [...emlpoymentData.otherIncome];
        newIncome[index] = {
            ...newIncome[index],
            [name]: value
        };
        setemlpoymentData({ ...emlpoymentData, otherIncome: newIncome });
        setErrors((prevData) => ({ ...prevData, [`${name}${index}`]: "" }));
    };

    //handle business input field change
    const handleBusinessInputChange = (index, name, e) => {
        const { value } = e.target;
        const newBusiness = [...emlpoymentData.business];
        newBusiness[index] = {
            ...newBusiness[index],
            [name]: value
        };
        setemlpoymentData({ ...emlpoymentData, business: newBusiness });
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[`${name}${index}`];
            return newErrors;
        });
    }

    const handleOtherIncomeAmountChange = (index, name, e) => {
        const { value } = e.target;
        let formattedValue = value;
        const newincomeAmount = [...emlpoymentData.otherIncome];
        newincomeAmount[index] = {
            ...newincomeAmount[index],
            [name]: formattedValue
        };
        setemlpoymentData({ ...emlpoymentData, otherIncome: newincomeAmount });
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[`${name}${index}`];
            return newErrors;
        });
    }

    const validateEmploymentData = () => {
        setFieldError(emlpoymentData.occupation, "occupation", "Please select an option.");
        setFieldError(emlpoymentData.employmentStartDate, "employmentStartDate", "Please select date.");
        setFieldError(emlpoymentData.employmentType, "employmentType", "Please select an option.");
        setFieldError(emlpoymentData.annualSalary, "annualSalary", "Salary info is required.");
        setFieldError(emlpoymentData.monthlySalary, "monthlySalary", "Please specify your monthly pay.");
        setFieldError(emlpoymentData.taxRate, "taxRate", "Tax rate is required.");
        setFieldError(emlpoymentData.employerName, "employerName", "Employer name is required.");
        setFieldError(emlpoymentData.companyRegisteredAddress, "companyRegisteredAddress", "Company's registered address is required.");
        setFieldError(emlpoymentData.previousEmployerName, "previousEmployerName", "Previous Employer name is required.");
        setFieldError(emlpoymentData.previousJobStartDate, "previousJobStartDate", "Previous job start date is required.");
        setFieldError(emlpoymentData.previousSalary, "previousSalary", "Previous salary info is required.");
        setFieldError(emlpoymentData.previousEmployersAddress, "previousEmployersAddress", "Previous company's address is required.");
    }

    const validateSelfEmploymentData = () => {
        emlpoymentData.business.forEach((business, index) => {
            setFieldError(business.businessRole, `businessRole${index}`, "Please select an option.");
            if (business.businessRole.value !== 'Sole Trader') {
                setFieldError(business.businessPercentage, `businessPercentage${index}`, "Business percentage is required.");
            }
            setFieldError(business.selfBusinessName, `selfBusinessName${index}`, "business name is required.");
            setFieldError(business.selfEmploymentDuration, `selfEmploymentDuration${index}`, "Please select employment duration.");
            setFieldError(business.latestAccountingYear, `latestAccountingYear${index}`, "Latest accounting years is required.");
            setFieldError(business.latestYearTotalIncome, `latestYearTotalIncome${index}`, "Latest year total income is required.");
            setFieldError(business.latestYearsNetProfit, `latestYearsNetProfit${index}`, "Latest year net profit is required.");
            setFieldError(business.latestYearsSalary, `latestYearsSalary${index}`, "Latest year salary is required.");
            setFieldError(business.latestYearsProfitFromLands, `latestYearsProfitFromLands${index}`, "Latest year's land profit is required.");
            setFieldError(business.latestYearsDividends, `latestYearsDividends${index}`, "Latest year's land profit is required.");
            setFieldError(business.previousAccountingYear, `previousAccountingYear${index}`, "Please choose previous accounting year.");
            setFieldError(business.previousYearTotalIncome, `previousYearTotalIncome${index}`, "Previous year total income is required.");
            setFieldError(business.previousYearsNetProfit, `previousYearsNetProfit${index}`, "Previous year net profit is required.");
            setFieldError(business.previousYearsSalary, `previousYearsSalary${index}`, "Previous year salary is required.");
            setFieldError(business.previousYearsProfitFromLands, `previousYearsProfitFromLands${index}`, "Previous year's land profit is required.");
            setFieldError(business.previousYearsDividends, `previousYearsDividends${index}`, "Please select an option.");
        });
    }

    const validateIncomeSource = () => {
        emlpoymentData.otherIncome.forEach((income, index) => {
            setFieldError(income.otherIncomeSource, `otherIncomeSource${index}`, "Please select an option.");
            setFieldError(income.otherIncomeAmount, `otherIncomeAmount${index}`, "Other income amount is requires.");
        })
    }

    var isValid = true;
    var newErrors = {};
    var firstErrorFieldId = null;
    const setFieldError = (field, fieldName, errorMsg) => {
        if (!field) {
            isValid = false;
            newErrors[fieldName] = errorMsg;
            if (!firstErrorFieldId) firstErrorFieldId = fieldName;
        }
    };

    const handleGoBack = () => {
        onPriviousPage()
    };

    //handle form submission
    const handleFormSubmission = async () => {
        setFieldError(emlpoymentData.employmentStatus, "employmentStatus", "Please select an option.");
        if (emlpoymentData.employmentStatus.value !== 'Neither') {
            setFieldError(emlpoymentData.retirementAge, "retirementAge", "retirement age is required.");
            if (emlpoymentData.employmentStatus.value === 'Employed') {
                validateEmploymentData();
            }
            if (emlpoymentData.employmentStatus.value === 'Self-Employed') {
                validateSelfEmploymentData();
            }
            if (emlpoymentData.employmentStatus.value === 'Both') {
                validateEmploymentData();
                validateSelfEmploymentData();
            }
        }
        setFieldError(emlpoymentData.universalCreditSource, "universalCreditSource", "Please select an option.");
        setFieldError(emlpoymentData.universalCreditAmount, "universalCreditAmount", "Please select an option.");
        setFieldError(emlpoymentData.universalCreditBank, "universalCreditBank", "Bank name is required.");
        setFieldError(emlpoymentData.NInumber, "NInumber", "NI number is required.");
        setFieldError(emlpoymentData.accountantFirm, "accountantFirm", "Name of accountant firm is required.");
        setFieldError(emlpoymentData.actingAccountant, "actingAccountant", "Name of acting accountant is required.");
        setFieldError(emlpoymentData.address, "address", "Address is required.");
        setFieldError(emlpoymentData.postCode, "postCode", "Post code is required.");
        setFieldError(emlpoymentData.otherIncomeStatus, "otherIncomeStatus", "Please select an option.");
        if (emlpoymentData.otherIncomeStatus.value === 'Yes') {
            validateIncomeSource()
        }
        setErrors(newErrors);
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (emlpoymentData.employmentStatus.value === "Neither" && emlpoymentData.otherIncomeStatus.value === "No") {
            MySwal.fire({
                icon: 'error',
                iconColor: '#AB1717',
                text: "It seems you've indicated no current income, which means we can't offer an Agreement in Principle or mortgage. If you do have regular income, please update the form. Otherwise, we'll need to end this request.",
                showCancelButton: true,
                cancelButtonText: 'Stay',
                showConfirmButton: true,
                confirmButtonText: 'Exit',
                confirmButtonColor: '#0A2266',
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/mortgage_dashboard');
                }
            });
            return
        }

        if (isValid) {
            try {
                const result = await api.post(`/employment-details/${applicationId}`, emlpoymentData);
                if (result.status == 200) {
                    Swal.fire({
                        icon: "success",
                        title: result.data.message,
                        iconColor: '#008000',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    onNextPage();
                }
            } catch (error) {
                console.log("post api error in employment form:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -120;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    };

    const saveFormData = async () => {
        var isValid = true;
        let firstErrorFieldId = null;
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (isValid) {
            try {
                const result = await api.post(`/employment-details/${applicationId}`, emlpoymentData);
                if (result.status === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Your details have been saved successfully",
                        iconColor: '#008000',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Exit ',
                        confirmButtonColor: '#0E2F4F',
                        cancelButtonText: 'Stay on Page',
                    }).then(async (response) => {
                        if (response.isConfirmed) {
                            navigate('/mortgage_dashboard');
                        }
                    });
                }
            } catch (error) {
                console.log("Post API error:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -220;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    };

    const addRemoveButtons = (name1, name2, type) => {
        const shouldShowRemoveButton =
            (type === 'income' && emlpoymentData.otherIncome.length > 1) ||
            (type === 'business' && emlpoymentData.business.length > 1);
        return (
            <div className="input-field-row">
                {shouldShowRemoveButton ? (
                    <button
                        className="removeDivButton"
                        onClick={() => removeDataDiv(type)}>
                        {name2}
                    </button>
                ) : (
                    <div className="removeDivButton"></div>
                )}
                <button
                    className="addDivButton"
                    onClick={() => addDataDiv(type)}>
                    {name1}
                </button>
            </div>
        )
    }

    const addDataDiv = (type) => {
        isValid = true;
        newErrors = {}
        if (type === 'business') {
            validateSelfEmploymentData()
            setErrors(newErrors);
            if (isValid) {
                setemlpoymentData((prevData) => ({
                    ...prevData,
                    business: [
                        ...prevData.business,
                        {
                            businessRole: '',
                            businessPercentage: '',
                            selfBusinessName: '',
                            selfEmploymentDuration: '',
                            latestAccountingYear: '',
                            latestYearTotalIncome: '',
                            latestYearsNetProfit: '',
                            latestYearsSalary: '',
                            latestYearsProfitFromLands: '',
                            latestYearsDividends: '',
                            previousAccountingYear: '',
                            previousYearTotalIncome: '',
                            previousYearsNetProfit: '',
                            previousYearsSalary: '',
                            previousYearsProfitFromLands: '',
                            previousYearsDividends: '',
                        }
                    ]
                }))
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Please fill above details first.",
                    iconColor: '#AB1717',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        } else if (type === 'income') {
            validateIncomeSource()
            setErrors(newErrors);
            if (isValid) {
                setemlpoymentData((prevData) => ({
                    ...prevData,
                    otherIncome: [
                        ...prevData.otherIncome,
                        {
                            otherIncomeSource: '',
                            otherIncomeAmount: '',
                        }
                    ]
                }))
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Please fill above details first.",
                    iconColor: '#AB1717',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
    }
    const removeDataDiv = (type) => {
        if (type === 'business') {
            var newBusiness = [...emlpoymentData.business];
            if (newBusiness.length > 1) {
                newBusiness = newBusiness.slice(0, newBusiness.length - 1);
                setemlpoymentData({ ...emlpoymentData, business: newBusiness });
            }
        } else if (type === 'income') {
            var newIncome = [...emlpoymentData.otherIncome];
            if (newIncome.length > 1) {
                newIncome = newIncome.slice(0, newIncome.length - 1);
                setemlpoymentData({ ...emlpoymentData, otherIncome: newIncome });
            }
        }
    }

    //employment form component
    const handleEmploymentForm = () => {
        return (
            <>
                <p className="formHeading">Employment Details</p>
                <SelectBox
                    label="Occupation:"
                    options={occupationList}
                    htmlFor="occupation"
                    value={emlpoymentData.occupation}
                    placeholder="Select your occupation"
                    onChange={(value) => handleSelectChange(value, 'occupation')}
                    styles={customSelectStyles('occupation')}
                />
                <DatePickerComponent
                    label="Start date of Employment:"
                    htmlFor="employmentStartDate"
                    value={emlpoymentData.employmentStartDate}
                    onChange={(date) => handleDateChange(date, 'employmentStartDate', "employmentStartDate")}
                />
                <SelectBox
                    label="Employment Type:"
                    htmlFor="employmentType"
                    placeholder="Select employment type"
                    options={employmentTypeList}
                    value={emlpoymentData.employmentType}
                    onChange={(value) => handleSelectChange(value, 'employmentType')}
                    styles={customSelectStyles('employmentType')}
                />
                <PriceInputBox
                    label="Basic Annual salary:"
                    htmlFor="annualSalary"
                    value={emlpoymentData.annualSalary}
                    placeholder="Enter your basic annual salary"
                    onChange={handlePriceChange}
                />
                <PriceInputBox
                    label="Net Monthly Pay:"
                    htmlFor="monthlySalary"
                    value={emlpoymentData.monthlySalary}
                    placeholder="Enter your net monthly pay"
                    onChange={handlePriceChange}
                />
                <PercentageInputBox
                    label="Tax Rate:"
                    htmlFor="taxRate"
                    value={emlpoymentData.taxRate}
                    onChange={handleInputChange}
                    placeholder="Enter your tax rate"
                />
                <InputField
                    label="Employer Name:"
                    htmlFor="employerName"
                    value={emlpoymentData.employerName}
                    onChange={handleInputChange}
                    placeholder="Enter your employer name"
                />
                <InputField
                    label="Enter Company's Registered Address:"
                    htmlFor="companyRegisteredAddress"
                    value={emlpoymentData.companyRegisteredAddress}
                    type="address"
                    onChange={handleInputChange}
                    placeholder="Enter company's registered address"
                />
                <InputField
                    label="Previous Employer Name:"
                    htmlFor="previousEmployerName"
                    value={emlpoymentData.previousEmployerName}
                    onChange={handleInputChange}
                    placeholder="Enter previous employer name"
                />
                <DatePickerComponent
                    label="Start date of Previous Employment:"
                    htmlFor="previousJobStartDate"
                    value={emlpoymentData.previousJobStartDate}
                    onChange={(date) => handleDateChange(date, 'previousJobStartDate', "previousJobStartDate")}
                />
                <PriceInputBox
                    label="Previous Salary:"
                    htmlFor="previousSalary"
                    value={emlpoymentData.previousSalary}
                    placeholder="Enter your previous salary"
                    onChange={handlePriceChange}
                />
                <InputField
                    label="Previous Employer's Address:"
                    htmlFor="previousEmployersAddress"
                    value={emlpoymentData.previousEmployersAddress}
                    onChange={handleInputChange}
                    type="address"
                    placeholder="Enter previous employer's address"
                />
            </>
        )
    }

    //self employment form component
    const handleSelfEmploymentForm = (business, index) => {
        return (
            <>
                <p className="formHeading">{`${index + 1}. Business Details`}</p>
                <SelectBox
                    label="Select your Business Role:"
                    htmlFor={`businessRole${index}`}
                    placeholder="Select your business role"
                    value={business.businessRole}
                    options={businessRoles}
                    onChange={(value) => handleBusinessChange(index, `businessRole`, value)}
                    styles={customSelectStyles(`businessRole${index}`)}
                />
                {business.businessRole && (business.businessRole.value !== 'Sole Trader') && (
                    <>
                        <PercentageInputBox
                            label="Enter Percentage of business you own:"
                            htmlFor={`businessPercentage${index}`}
                            value={business.businessPercentage}
                            onChange={(value) => handleBusinessInputChange(index, "businessPercentage", value)}
                            placeholder="Enter percentage of business you own"
                        />
                    </>
                )}
                <InputField
                    label="Enter Name of Your Business:"
                    htmlFor={`selfBusinessName${index}`}
                    value={business.selfBusinessName}
                    onChange={(value) => handleBusinessInputChange(index, "selfBusinessName", value)}
                    placeholder="Enter your business name"
                />
                <DatePickerComponent
                    label="What is the duration of your current Self-Employment?"
                    htmlFor={`selfEmploymentDuration${index}`}
                    value={business.selfEmploymentDuration}
                    onChange={(date) => handleBusinessChange(index, 'selfEmploymentDuration', date)}
                />
                <p className="formHeading">Latest Accounting Year Details</p>
                <DatePickerComponent
                    label="Latest Accounting Year:"
                    htmlFor={`latestAccountingYear${index}`}
                    value={business.latestAccountingYear}
                    onChange={(date) => handleBusinessChange(index, 'latestAccountingYear', date)}
                />
                <PriceInputBox
                    label="Latest years's Total Income:"
                    htmlFor={`latestYearTotalIncome${index}`}
                    value={business.latestYearTotalIncome}
                    placeholder="Enter your latest years's total income"
                    onChange={(value) => handleBusinessInputChange(index, "latestYearTotalIncome", value)}
                />
                <PriceInputBox
                    label="Latest year's Net Profit:"
                    htmlFor={`latestYearsNetProfit${index}`}
                    value={business.latestYearsNetProfit}
                    placeholder="Enter your latest years's net profit"
                    onChange={(value) => handleBusinessInputChange(index, "latestYearsNetProfit", value)}
                />
                <PriceInputBox
                    label="Latest year's Salary:"
                    htmlFor={`latestYearsSalary${index}`}
                    value={business.latestYearsSalary}
                    placeholder="Enter your latest years's salary"
                    onChange={(value) => handleBusinessInputChange(index, "latestYearsSalary", value)}
                />
                <PriceInputBox
                    label="Latest year's Profit From Lands:"
                    htmlFor={`latestYearsProfitFromLands${index}`}
                    value={business.latestYearsProfitFromLands}
                    placeholder="Enter your latest years's profit from lands"
                    onChange={(value) => handleBusinessInputChange(index, "latestYearsProfitFromLands", value)}
                />
                <PriceInputBox
                    label="Latest year's Dividends:"
                    htmlFor={`latestYearsDividends${index}`}
                    value={business.latestYearsDividends}
                    placeholder="Enter your latest years's dividends"
                    onChange={(value) => handleBusinessInputChange(index, "latestYearsDividends", value)}
                />
                <p className="formHeading">Previous Accounting Year Details</p>
                <DatePickerComponent
                    label="Previous Accounting Year:"
                    htmlFor={`previousAccountingYear${index}`}
                    value={business.previousAccountingYear}
                    onChange={(date) => handleBusinessChange(index, 'previousAccountingYear', date)}
                />
                <PriceInputBox
                    label="Previous years's Total Income:"
                    htmlFor={`previousYearTotalIncome${index}`}
                    value={business.previousYearTotalIncome}
                    placeholder="Enter your previous years's total income"
                    onChange={(value) => handleBusinessInputChange(index, "previousYearTotalIncome", value)}
                />
                <PriceInputBox
                    label="Previous year's Net Profit:"
                    htmlFor={`previousYearsNetProfit${index}`}
                    value={business.previousYearsNetProfit}
                    placeholder="Enter your previous years's net profit"
                    onChange={(value) => handleBusinessInputChange(index, "previousYearsNetProfit", value)}
                />
                <PriceInputBox
                    label="Previous year's Salary:"
                    htmlFor={`previousYearsSalary${index}`}
                    value={business.previousYearsSalary}
                    placeholder="Enter your previous years's salary"
                    onChange={(value) => handleBusinessInputChange(index, "previousYearsSalary", value)}
                />
                <PriceInputBox
                    label="Previous year's Profit From Lands:"
                    htmlFor={`previousYearsProfitFromLands${index}`}
                    value={business.previousYearsProfitFromLands}
                    placeholder="Enter your previous years's profit from lands"
                    onChange={(value) => handleBusinessInputChange(index, "previousYearsProfitFromLands", value)}
                />
                <PriceInputBox
                    label="Previous year's Dividends:"
                    htmlFor={`previousYearsDividends${index}`}
                    value={business.previousYearsDividends}
                    placeholder="Enter your previous years's dividends"
                    onChange={(value) => handleBusinessInputChange(index, "previousYearsDividends", value)}
                />
            </>
        )
    }

    //universal creadits form component
    const handleUniversalCreditForm = () => {
        return (
            <>
                <p className="formHeading">Universal Credits Details</p>
                <SelectBox
                    label="Select Source of  Universal Credits:"
                    htmlFor="universalCreditSource"
                    options={universalBenifitsList}
                    placeholder="Select other income source"
                    value={emlpoymentData.universalCreditSource}
                    onChange={(value) => handleSelectChange(value, 'universalCreditSource')}
                    styles={customSelectStyles('universalCreditSource')}
                />
                <PriceInputBox
                    label="Amount Recieved Per Month:"
                    htmlFor="universalCreditAmount"
                    value={emlpoymentData.universalCreditAmount}
                    placeholder="Enter amount you recieved per month"
                    onChange={handlePriceChange}
                />
                <InputField
                    label="Enter Bank Name:"
                    htmlFor="universalCreditBank"
                    value={emlpoymentData.universalCreditBank}
                    onChange={handleInputChange}
                    placeholder="Enter your bank name"
                />
                {emlpoymentData.otherIncomeSource && emlpoymentData.otherIncomeSource.value !== '' && (
                    <>

                    </>
                )}
            </>
        )
    }

    //any other income details form component
    const handleOtherIncomeForm = (income, index) => {
        return (
            <>
                {emlpoymentData.otherIncomeStatus && emlpoymentData.otherIncomeStatus.value === 'Yes' && (
                    <>
                        <p className="formHeading">{`${index + 1}. Income Details`}</p>
                        <SelectBox
                            label="Select Other Income Source"
                            htmlFor={`otherIncomeSource${index}`}
                            options={otherIncomeList}
                            placeholder="Select other income source"
                            value={income.otherIncomeSource}
                            onChange={(value) => handleIncomeChange(index, 'otherIncomeSource', value)}
                            styles={customSelectStyles(`otherIncomeSource${index}`)}
                        />
                        <PriceInputBox
                            label="Amount:"
                            htmlFor={`otherIncomeAmount${index}`}
                            value={income.otherIncomeAmount}
                            placeholder="Enter amount recieved from other source"
                            onChange={(value) => handleOtherIncomeAmountChange(index, "otherIncomeAmount", value)}
                        />

                    </>
                )}
            </>
        )
    }

    //accounting data form component
    const handleAccountingForm = () => {
        return (
            <>
                <hr />
                <p className="formHeading">Accounting Details</p>
                <InputField
                    label="National Insurance (NI) Number:"
                    htmlFor="NInumber"
                    value={emlpoymentData.NInumber}
                    type="niNumber"
                    onChange={handleInputChange}
                    placeholder="Enter your NI number"
                />
                <InputField
                    label="Name of Accountants Firm:"
                    htmlFor="accountantFirm"
                    value={emlpoymentData.accountantFirm}
                    onChange={handleInputChange}
                    placeholder="Enter name of your accountant firm"
                />
                <InputField
                    label="Name of Acting Accountant:"
                    htmlFor="actingAccountant"
                    value={emlpoymentData.actingAccountant}
                    onChange={handleInputChange}
                    placeholder="Enter name of your acting accountant"
                />
                <InputField
                    label="Address:"
                    htmlFor="address"
                    value={emlpoymentData.address}
                    type="address"
                    onChange={handleInputChange}
                    placeholder="Enter address"
                />
                <InputField
                    label="Enter Post Code:"
                    htmlFor="postCode"
                    value={emlpoymentData.postCode}
                    type="postCode"
                    onChange={handleInputChange}
                    placeholder="Enter your post code"
                />
            </>
        )
    }



    //form return
    return (
        <>
            <div className="personal-details-form">
                <div className="form_name">Employment Details
                    <p>All fields are required to submit the application
                        <span className="required">*</span>
                    </p>
                </div>
                <SelectBox
                    isMulti={true}
                    label="Select Employment Status:"
                    options={employmentStatus}
                    htmlFor="employmentStatus"
                    name="employmentStatus"
                    value={emlpoymentData.employmentStatus}
                    placeholder='Select employment status'
                    onChange={(value) => handleSelectChange(value, 'employmentStatus')}
                    styles={customSelectStyles('employmentStatus')}
                />
                {emlpoymentData.employmentStatus && emlpoymentData.employmentStatus.value !== 'Neither' && (
                    <InputField
                        label="Retirement Age:"
                        htmlFor="retirementAge"
                        value={emlpoymentData.retirementAge}
                        onChange={handleInputChange}
                        placeholder="Enter your retirement age"
                        type="number"
                    />
                )}
                {emlpoymentData.employmentStatus.value === 'Employed' && (
                    <>
                        <hr /> {handleEmploymentForm()}
                        <hr /> {handleUniversalCreditForm()} {handleAccountingForm()}

                    </>
                )}
                {emlpoymentData.employmentStatus.value === 'Self-Employed' && (
                    <> <hr />
                        <p className="formHeading">Self Employment Details</p>
                        {emlpoymentData.business && emlpoymentData.business.map((business, index) => (
                            <div key={index}>
                                {index !== 0 && (<hr />)}
                                {handleSelfEmploymentForm(business, index)}
                            </div>
                        ))}
                        {addRemoveButtons("Add more business", "Remove business", 'business')}
                        <hr />
                        {handleUniversalCreditForm()} {handleAccountingForm()}
                    </>
                )}
                {emlpoymentData.employmentStatus && emlpoymentData.employmentStatus.value === 'Both' && (
                    <>
                        <hr /> {handleEmploymentForm()}
                        <hr />
                        <p className="formHeading">Self Employment Details</p>
                        {emlpoymentData.business && emlpoymentData.business.map((business, index) => (
                            <div key={index}>
                                {index !== 0 && (<hr />)}
                                {handleSelfEmploymentForm(business, index)}
                            </div>
                        ))}
                        {addRemoveButtons("Add more business", "Remove business", 'business')}
                        <hr /> {handleUniversalCreditForm()} {handleAccountingForm()}
                    </>
                )}
                <hr />
                {emlpoymentData.employmentStatus && emlpoymentData.employmentStatus.value === 'Neither' && (
                    <>
                        {handleUniversalCreditForm()} {handleAccountingForm()}<hr />
                    </>
                )}
                <p className="formHeading">Other Income Details</p>
                <SelectBox
                    label="Do you have any other income ?"
                    htmlFor="otherIncomeStatus"
                    placeholder="Select an option"
                    options={yesNoArray}
                    value={emlpoymentData.otherIncomeStatus}
                    onChange={(value) => handleSelectChange(value, 'otherIncomeStatus')}
                    styles={customSelectStyles('otherIncomeStatus')}
                />
                {emlpoymentData.otherIncomeStatus && emlpoymentData.otherIncomeStatus.value === 'Yes' && (
                    <>
                        {emlpoymentData.otherIncome && emlpoymentData.otherIncome.map((income, index) => (
                            <div key={index}>
                                {index !== 0 && (<hr />)}
                                {handleOtherIncomeForm(income, index)}
                            </div>
                        ))}
                        {addRemoveButtons('Add another Income Details', 'Remove Income details', 'income')}
                    </>
                )}
                <div className="buttons-style">
                    <div className="back-btn"><ButtonComponent name="Back" onClick={handleGoBack} /></div>
                    <div className="button-div">
                        <ButtonComponent name='Save & Exit' onClick={saveFormData} />
                        <ButtonComponent label="Submit" name='Continue' onClick={handleFormSubmission} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmploymentStatus;